import { HubFeature } from '@ats/api/cm';
import { LocDefs, MapLocKeys } from '@cm/core/localization';

const dpRoot = 'Scheduling|Schedule an Exam|Caveon';

export type SSOEgressCDI =
	| 'CPSSOEgressCDIButton'
	| 'CPSSOEgressCDILoadingMessage'
	| 'CPSSOEgressCDIRedirectFailure'
	| 'CPSSOEgressCDINoExamCode'
	| 'CPSSOEgressCDITabTitle'
	| 'CPSSOEgressCDIPageTitle'
	| 'CPSSOEgressCDIPageDescription';

export const ssoEgressCDILocs: LocDefs<SSOEgressCDI> = {
	CPSSOEgressCDIButton: {
		defaultValue: 'SSO to Caveon',
		description: 'Button to SSO to Caveon.',
		displayPath: `${dpRoot}|SSO Button`,
		displayType: 'Button',
		feature: HubFeature.CandidateAccessIntegrationEgressOidcEgressCaveon,
		portal: 'CP',
		htmlAllowed: false,
	},
	CPSSOEgressCDILoadingMessage: {
		defaultValue: 'Connecting to provider',
		description: 'Message displayed while SSO is in flight.',
		displayPath: `${dpRoot}|SSO Loading Message`,
		displayType: 'Content',
		feature: HubFeature.CandidateAccessIntegrationEgressOidcEgressCaveon,
		portal: 'CP',
		htmlAllowed: false,
	},
	CPSSOEgressCDIRedirectFailure: {
		defaultValue:
			'You should be automatically redirected in a moment, but if you are not, please click the button below.',
		description: 'Message displayed if auto redirect fails.',
		displayPath: `${dpRoot}|SSO Redirect Failure`,
		displayType: 'Content',
		feature: HubFeature.CandidateAccessIntegrationEgressOidcEgressCaveon,
		portal: 'CP',
		htmlAllowed: true,
	},
	CPSSOEgressCDINoExamCode: {
		defaultValue: 'No exam selected to schedule.',
		description: 'Message displayed if no exam code is provided.',
		displayPath: `${dpRoot}|No Exam Code`,
		displayType: 'Content',
		feature: HubFeature.CandidateAccessIntegrationEgressOidcEgressCaveon,
		portal: 'CP',
		htmlAllowed: true,
	},
	CPSSOEgressCDITabTitle: {
		defaultValue: 'Schedule an Exam',
		description: 'Tab title of CDI SSO page.',
		displayPath: `${dpRoot}|Tab Title`,
		displayType: 'Title',
		feature: HubFeature.CandidateAccessIntegrationEgressOidcEgressCaveon,
		portal: 'CP',
		htmlAllowed: false,
	},
	CPSSOEgressCDIPageTitle: {
		defaultValue: 'Caveon SSO',
		description: 'Title of Caveon SSO page.',
		displayPath: `${dpRoot}|Title`,
		displayType: 'Title',
		feature: HubFeature.CandidateAccessIntegrationEgressOidcEgressCaveon,
		portal: 'CP',
		htmlAllowed: false,
	},
	CPSSOEgressCDIPageDescription: {
		defaultValue: '',
		description: 'Title of Caveon SSO page.',
		displayPath: `${dpRoot}|Page Description`,
		displayType: 'Content',
		feature: HubFeature.CandidateAccessIntegrationEgressOidcEgressCaveon,
		portal: 'CP',
		htmlAllowed: true,
	},
};

export const cpSSOEgressCDILocKeys = MapLocKeys<SSOEgressCDI>(ssoEgressCDILocs);
export type cpCDISSOLocKeyType = typeof cpSSOEgressCDILocKeys;
